import React from "react"; // Importing React library
import styled from "styled-components"; // Importing styled-components library
import Theme from '../../../styles/Theme/Theme'; // Importing Theme
import { IconBase64 } from "@synergy/icons";

//#region  Styled Components
const MouseoverTooltipWrapper = styled.div`
    height: auto;
    width: auto;
    max-height: 300px;
    overflow-y: auto;
`;

const MouseoverTooltipIncidentContent = styled.div`
    display: grid;
    gap: ${Theme.spacing.s06}; 
    width: auto;
    padding: ${Theme.spacing.s01};
`

const Hr = styled.div`
    width: 100%;
    height: 1px;
    background: var(--Neutral-3, #DCE3E5);
`;
//#endregion 

// Functional component for the mouseover tooltip
const MouseoverTooltip = ({ data, isSvgIcons }) => {
    try {
        return (
            <MouseoverTooltipWrapper>
                {data.map((item, index) => {
                    // Get base64 icon using IconBase64 function
                    const iconBase64 = IconBase64({
                        class: item.class,
                        family: item.family,
                        label: item.label || 'Incident',
                        priority: item.priority
                    });
                    
                    return (
                        <MouseoverTooltipIncidentContent key={index}>
                            <div
                                style={{
                                    gridColumn: "1",
                                    gridRow: "1",
                                }}
                            >
                                <img src={iconBase64} width='30px' height='30px' alt='tooltip icon' />
                            </div>
                            {item?.fields.map((field, index) => {
                                const gridColumns = item.gridColumns ?? 2;
                                const rowIndex = Math.floor(index / gridColumns);
                                const fieldGridRow = rowIndex * 2 + 1;
                                const isLastInRow = (index + 1) % gridColumns === 0;
                                const isNotLastField = index < item.fields.length - 1;

                                return (
                                    <React.Fragment key={index}>
                                        <div
                                            style={{
                                                gridColumn: `${(index % gridColumns) + 2}`,
                                                gridRow: fieldGridRow,
                                            }}
                                        >
                                            <PropertiesBox
                                                title={field.fieldName}
                                                value={field.value}
                                            />
                                        </div>
                                        {isLastInRow && isNotLastField && (
                                            <Hr
                                                style={{
                                                    gridColumn: `1 / span ${gridColumns + 1}`,
                                                    gridRow: fieldGridRow + 1,
                                                }}
                                            />
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </MouseoverTooltipIncidentContent>
                    )
                })}
            </MouseoverTooltipWrapper >
        )
    } catch (error) {
        console.error('(MouseoverTooltip page) Error rendering MouseoverTooltip:', error);
        //reportError(error); // Send error report to backend
    }
};

const PropertyValue = styled.div`
  max-width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const PropertiesBox = ({ title, value }) => {
    return (
        <div>
            <div style={{ color: '#63666A' }}>{title}</div>
            <PropertyValue>{value}</PropertyValue>
        </div>
    )
};

export default MouseoverTooltip; // Exporting the MouseoverTooltip component